import { useEffect, useState } from 'react';
import { tenantApi, type Tenant } from '../../api';

export default function SettingsChambers() {
  const [tenant, setTenant] = useState<Tenant | null>(null);
  const [patch, setPatch] = useState<Partial<Tenant>>({});
  const [message, setMessage] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    tenantApi.get()
      .then((r) => setTenant(r.tenant))
      .catch((e: Error) => setError(e.message || 'Could not load chambers settings.'));
  }, []);

  const save = async () => {
    if (!Object.keys(patch).length) return;
    try {
      await tenantApi.update(patch);
      setMessage('Saved.');
      const r = await tenantApi.get();
      setTenant(r.tenant);
      setPatch({});
    } catch (e) {
      setError((e as Error).message);
    }
  };

  if (error) {
    return (
      <div className="card" style={{ maxWidth: 640, borderColor: 'var(--color-danger)' }}>
        <b>Could not load chambers settings</b>
        <p className="muted" style={{ marginTop: 6, fontSize: 13 }}>{error}</p>
        <p className="muted" style={{ fontSize: 12 }}>If this persists, the current role may not have <code>tenant.read</code> capability — ask the chambers owner.</p>
      </div>
    );
  }
  if (!tenant) return <div className="muted">Loading…</div>;
  const v = <K extends keyof Tenant>(k: K): Tenant[K] => (patch[k] !== undefined ? patch[k] : tenant[k]) as Tenant[K];
  const set = <K extends keyof Tenant>(k: K, val: Tenant[K]) => setPatch({ ...patch, [k]: val });

  return (
    <div style={{ maxWidth: 640 }} className="stack">
      <h1>Chambers settings</h1>
      <div className="card stack">
        <div>
          <label>Name</label>
          <input value={v('name') as string} onChange={(e) => set('name', e.target.value)} />
        </div>
        <div>
          <label>Legal name (if different)</label>
          <input value={(v('legal_name') as string) || ''} onChange={(e) => set('legal_name', e.target.value)} />
        </div>
        <div className="row">
          <div className="grow">
            <label>VAT number</label>
            <input value={(v('vat_number') as string) || ''} onChange={(e) => set('vat_number', e.target.value)} />
          </div>
          <div className="grow">
            <label>Tax number</label>
            <input value={(v('tax_number') as string) || ''} onChange={(e) => set('tax_number', e.target.value)} />
          </div>
        </div>
        <div className="row">
          <div className="grow">
            <label>Default currency</label>
            <input value={v('default_currency') as string} onChange={(e) => set('default_currency', e.target.value)} />
          </div>
          <div className="grow">
            <label>Timezone</label>
            <input value={v('default_timezone') as string} onChange={(e) => set('default_timezone', e.target.value)} />
          </div>
        </div>
        {message && <div style={{ color: 'var(--color-success)' }}>{message}</div>}
        <button className="primary" onClick={save}>Save</button>
      </div>
    </div>
  );
}
